import React from 'react';

const SaleStartingPage = () => {
  return (
    <section className='page-container'>
      <div className='order-page sale-status-stage'>
        <div className='center-items-horizontal'>
            <div className='page-header'>
                <h2>LVLCS x WORLD MOBILE TOKEN FOOTBALL JERSEY IRL</h2>
                <p className='minting-text'>MINTING IS COMING SOON!</p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default SaleStartingPage;